// extracted by mini-css-extract-plugin
export default {"barChartContainer":"styles_barChartContainer__wZq15"};